import {enableProdMode, provideZoneChangeDetection} from '@angular/core'


import {environment} from './environments/environment'
import {registerLocaleData} from '@angular/common'
import {bootstrapApplication} from '@angular/platform-browser'
import {AppComponent} from './app/app.component'
import localeFr from '@angular/common/locales/fr'
import {appConfig} from './app/app.config'

registerLocaleData(localeFr)

if (environment.production) {
  enableProdMode()
}


bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch(err => console.error(err))
